export default __webpack_public_path__ + "static/media/files.80598c8f.svg";